import axios from "axios";
import React, { useEffect, useState } from "react";
import { Redirect } from "react-router-dom";
import { API_BASE_URL } from "../config";
import { Route, } from 'react-router-dom';

const Loader = () => {
    return (
        <div style={{ textAlign: "center", marginTop: "20px" }}>
            <div style={styles.loader}></div>
            <p>Loading...</p>
        </div>
    );
};

const styles = {
    loader: {
        border: "8px solid #ff9b44",
        borderTop: "8px solid #fc6075",
        borderRadius: "50%",
        width: "50px",
        height: "50px",
        animation: "spin 2s linear infinite",
        margin: "0 auto"
    }
};




const PrivateRoute = ({ children, ...rest }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(null);

    useEffect(() => {
        const fetchAuthStatus = async () => {
            try {
                const response = await axios.get(`${API_BASE_URL}/showemployee`, {
                    headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
                });
                setIsAuthenticated(!!response.data.name);
            } catch {
                setIsAuthenticated(false);
            }
        };
        fetchAuthStatus();
    }, []);

    if (isAuthenticated === null) return <Loader />;

    return (
        <Route
            {...rest}
            render={(props) =>
                isAuthenticated ? children : <Redirect to="/login" />
            }
        />
    );
};

const PublicRoute = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(null);

    useEffect(() => {
        const fetchAuthStatus = async () => {
            try {
                const response = await axios.get(`${API_BASE_URL}/showemployee`, {
                    headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}`,Accept: "application/json" },
                });
                setIsAuthenticated(!!response.data.name);
            } catch {
                setIsAuthenticated(false);
            }
        };
        fetchAuthStatus();
    }, []);

    if (isAuthenticated === null) return <Loader />;

    return isAuthenticated ? <Redirect to="/dashboard" /> : children;
};

export { PrivateRoute, PublicRoute };
